import { useSeo } from "@/lib/useSeo";
import { useSettings } from "@/lib/SettingsContext";
import { IMG } from "@/lib/images";
import { PageHeader, Section, Prose, Disclaimer } from "@/components/Editorial";

const POINTS = ["Approche", "Principes", "Accompagnement", "État hypnotique", "Objectifs", "Précautions", "Limites"];

export default function Hypnose() {
  const settings = useSettings();
  const tarif = settings?.hypnose_tarif;

  useSeo({
    title: "Hypnose Ericksonienne",
    description: "L'hypnose ericksonienne selon Dorothée Lancelot : approche, principes, accompagnement et limites, sans promesse médicale.",
    path: "/hypnose",
    keywords: ["hypnose ericksonienne", "séance d'hypnose", "hypnothérapie", "hypnose pour gérer le stress", "hypnose confiance en soi", "hypnose lâcher-prise", "accompagnement par l'hypnose"],
  });

  return (
    <div>
      <PageHeader
        eyebrow="Accompagnement"
        title="Hypnose Ericksonienne"
        intro="Une approche douce et respectueuse, fondée sur le langage, la suggestion et les ressources propres à chacun."
        image={IMG.candle}
      />
      <Section>
        <Prose>
          <p>
            L'hypnose ericksonienne s'appuie sur un état de conscience modifié, naturel et sécurisant, dans
            lequel l'attention se recentre. Il ne s'agit pas de perdre le contrôle, mais de mobiliser ses
            propres ressources, en douceur, vers un objectif défini ensemble.
          </p>
        </Prose>

        <div className="mt-10 flex flex-wrap gap-2.5">
          {POINTS.map((p, i) => (
            <span key={i} className="px-4 py-2 text-sm border border-[rgba(198,167,106,0.25)] text-[#F3E9D2]/75">{p}</span>
          ))}
        </div>

        <div className="mt-12 dl-card p-8 max-w-md">
          <div className="dl-eyebrow mb-2">Tarif</div>
          {tarif ? <div className="serif text-4xl text-[#D4B978]">{tarif}</div>
            : <div className="serif text-2xl italic text-[#F3E9D2]/50">Communiqué sur demande</div>}
        </div>

        <Disclaimer>L'hypnose ericksonienne ne fait l'objet d'aucune promesse médicale et ne remplace pas un avis ou un suivi médical.</Disclaimer>
      </Section>
    </div>
  );
}
